import React, { useState, useEffect } from 'react';
import api from '../api';

export default function ThreadsSection({ token, setError }) {
  const [threads, setThreads] = useState(null);
  const [newThread, setNewThread] = useState({ title: '', content: '', user_id: '' });

  const fetch = async () => {
    try {
      const res = await api.get('/admin/threads', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setThreads(res.data.threads);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch threads');
    }
  };

  useEffect(() => {
    if (!token) return;
    fetch();
  }, [token]);

  if (!threads) return null;

  return (
    <div className="mb-6">
      <h3 className="text-xl font-semibold mb-4 text-indigo-600">Threads</h3>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await api.post(
              '/admin/threads',
              newThread,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            setNewThread({ title: '', content: '', user_id: '' });
            fetch();
          } catch (err) {
            setError(err.response?.data?.error || '');
          }
        }}
        className="mb-4 flex flex-wrap gap-2"
      >
        <input
          placeholder="title"
          value={newThread.title}
          onChange={(e) => setNewThread({ ...newThread, title: e.target.value })}
          className="border rounded px-2"
        />
        <input
          placeholder="content"
          value={newThread.content}
          onChange={(e) => setNewThread({ ...newThread, content: e.target.value })}
          className="border rounded px-2"
        />
        <input
          placeholder="user_id (optional)"
          value={newThread.user_id}
          onChange={(e) => setNewThread({ ...newThread, user_id: e.target.value })}
          className="border rounded px-2"
        />
        <button className="bg-blue-600 text-white px-3 rounded shadow hover:bg-blue-700 transition">Add</button>
      </form>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {threads.map((t) => (
          <div
            key={t.id}
            className="p-4 bg-white rounded-lg shadow hover:shadow-lg transition flex justify-between items-start"
          >
            <div>
              <div className="font-medium">{t.title}</div>
              <div className="text-sm text-gray-500">by {t.user_name || 'anon'}</div>
            </div>
            <button
              className="text-red-500 hover:text-red-700"
              onClick={async () => {
                await api.delete(`/admin/threads/${t.id}`, {
                  headers: { Authorization: `Bearer ${token}` },
                });
                fetch();
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
